// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"24bb45a0","732":"698d739f","977":"cb83cf5b"}[chunkId] + ".chunk.js";
};